import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api, { asList } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { useFavorites } from "@/context/FavoritesContext";

export default function Favoritos() {
  const { ids } = useFavorites();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(asList(r.data))).catch(() => setProducts([]));
  }, []);

  const favIds = Array.isArray(ids) ? ids : [];
  const favs = asList(products).filter((p) => p?.id && favIds.includes(p.id));

  return (
    <div className="mx-auto max-w-[1280px] px-4 py-10 sm:px-6">
      <nav className="mb-4 font-sans text-xs text-ink/50">Início / <span className="text-forest-deep">Favoritos</span></nav>
      <h1 className="flex items-center gap-3 font-serif text-3xl font-semibold text-forest-deep sm:text-4xl">
        <Heart size={28} className="text-clay" fill="#3E7D4F" stroke="#3E7D4F" /> Meus Favoritos
      </h1>
      <p className="mt-2 font-sans text-sm text-ink/60">Seus produtos salvos ficam guardados aqui para você voltar quando quiser.</p>

      {favs.length === 0 ? (
        <div className="mt-10 rounded-2xl border border-dashed border-borderlight bg-sand-elevated py-20 text-center">
          <Heart size={40} className="mx-auto text-ink/25" />
          <p className="mt-4 font-serif text-2xl text-ink/60">Você ainda não tem favoritos</p>
          <p className="mt-1 font-sans text-sm text-ink/50">Toque no coração dos produtos para salvá-los aqui.</p>
          <Link to="/loja" data-testid="favorites-shop-btn"
            className="mt-6 inline-block rounded-lg bg-forest-deep px-8 py-3.5 font-sans text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-clay">
            Explorar produtos
          </Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {favs.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
